<idp-generic-content
  *ngIf="content.content && content.title"
  [message]="content.content"
  [title]="content.title"
></idp-generic-content>
